export interface RemoveForbiddenParameters {
  forbiddenParameters: ReadonlyArray<string>;
}

export const removeForbiddenParameters = ({
  forbiddenParameters,
}: RemoveForbiddenParameters) => {
  const urlParams = new URLSearchParams(window.location.search);
  const oldSearch = urlParams.toString();

  forbiddenParameters.forEach(param => {
    urlParams.delete(param);
  });

  const newSearch = urlParams.toString();
  let newUrl = window.location.pathname;
  if (newSearch) {
    newUrl += `?${newSearch}`;
  }

  if (newSearch === oldSearch) return;

  window.history.replaceState(null, '', newUrl);
};

export interface InjectGoogleTagManager {
  measurementId: string;
  forbiddenParameters: ReadonlyArray<string>;
}

export const injectGoogleTagManager = ({
  measurementId,
  forbiddenParameters,
}: InjectGoogleTagManager) => {
  const urlParams = new URLSearchParams(window.location.search);

  // We should not initialize analytics if we have blacklisted url params
  if (hasForbiddenParams({ urlParams, forbiddenParameters })) return;

  const head = document.getElementsByTagName('head')[0];

  const gtagScript = document.createElement('script');
  gtagScript.type = 'text/javascript';
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  gtagScript.async = true;

  head?.appendChild(gtagScript);
};

export interface HasForbiddenParams {
  urlParams: URLSearchParams;
  forbiddenParameters: ReadonlyArray<string>;
}

const hasForbiddenParams = ({
  urlParams,
  forbiddenParameters,
}: HasForbiddenParams): boolean => {
  return forbiddenParameters.some(param => urlParams.has(param));
};
